<template>
    <td-dialog
        :title="$t(title)"
        @cancel="columnDialogClose"
        :before-close="columnDialogClose"
        :visible.sync="dialogColumnVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="330px"
        top="18vh"
    >
        <el-form :model="formColumn" :label-width="formLabelWidth" ref="formColumn" :rules="rules">
            <el-form-item :label="$t('pgCommon.I_ORDER')" prop="iOrder">
                <td-input-number v-model="formColumn.iOrder" :min="1"></td-input-number>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.COLUMN_NAME')" prop="sColumnName">
                <td-input v-model="formColumn.sColumnName" :disabled="!isAddData" maxlength="100"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.COLUMN_NOTES')">
                <td-input v-model="formColumn.sColumnNotes" :disabled="!isAddData" maxlength="100"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.SETTINGS')">
                <td-checkbox v-model="formColumn.iPrimaryKey" @change="pryChange" :disabled="!isAddData">{{ $t('pgCommon.PRIMARY_KEY') }}</td-checkbox>
                <td-checkbox v-model="formColumn.iCanEmpty" :disabled="!isAddData">{{ $t('pgCommon.NOT_EMPTY') }}</td-checkbox>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.UI_TYPE')">
                <td-select v-model="formColumn.sUiType" :options="optionsUiType" @change="uiTypeChange"></td-select>
            </el-form-item>
            <el-form-item v-if="validityVisable" :label="$t('pgCommon.VALIDITY_CHECK')">
                <td-select v-model="formColumn.sValidityId" :options="optionsCheck"></td-select>
            </el-form-item>
            <el-form-item v-if="dictionaryVisable" :label="$t('pgCommon.TABLE_DICTIONARY')">
                <td-select v-model="formColumn.sDictionaryId" :options="optionsDic" keys="sId" text="sTableNotes" @change="dictionaryChange"></td-select>
            </el-form-item>
            <el-form-item v-if="groupIdVisable" :label="$t('pgCommon.GROUP_COLUMN')">
                <td-select v-model="formColumn.sGroupId" :options="optionsColumn" keys="sColumnId" text="sColumnNotes"></td-select>
            </el-form-item>
            <el-form-item v-if="groupMarkVisable" :label="$t('pgCommon.GROUP_MARK')">
                <td-input v-model="formColumn.sGroupMark" maxlength="100"></td-input>
            </el-form-item>
            <el-form-item v-if="defaultValueInput" :label="$t('pgCommon.DEFAULT_VALUE')">
                <td-input v-model="formColumn.sDefaultValue" maxlength="100"></td-input>
            </el-form-item>
            <el-form-item v-if="defaultValueNumber" :label="$t('pgCommon.DEFAULT_VALUE')">
                <td-input-number v-model="formColumn.sDefaultValue"></td-input-number>
            </el-form-item>
            <el-form-item v-if="defaultValueTime" :label="$t('pgCommon.DEFAULT_VALUE')">
                <td-date-time type="time" :placeholder="$t('pgCommon.SELECT_DATE')" v-model="formColumn.sDefaultValue"></td-date-time>
            </el-form-item>
            <el-form-item v-if="defaultValueDate" :label="$t('pgCommon.DEFAULT_VALUE')">
                <td-date-time type="date" :placeholder="$t('pgCommon.SELECT_DATE')" v-model="formColumn.sDefaultValue"></td-date-time>
            </el-form-item>
            <el-form-item v-if="defaultValueDateTime" :label="$t('pgCommon.DEFAULT_VALUE')">
                <td-date-time type="datetime" :placeholder="$t('pgCommon.SELECT_DATE')" v-model="formColumn.sDefaultValue"></td-date-time>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formColumn')">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import dlgColumnApi from './../assets/api.js';
export default {
    props: ['title', 'dialogColumnVisible', 'editItemCl', 'EditInitWidgetDate'],
    created() {
        // 为编辑状态则进行初始化数据
        this.editItemNew = this.editItemCl;
        // 获取字段对应的控件类型
        let widgetType = this.getColumnType(this.editItemNew.sColumnType);
        if (widgetType === 'inputNumber') {
            this.defaultValueInput = false;
            this.defaultValueNumber = true;
            this.defaultValueTime = false;
            this.defaultValueDate = false;
            this.defaultValueDateTime = false;
        } else if (widgetType === 'input') {
            this.defaultValueInput = true;
            this.defaultValueNumber = false;
            this.defaultValueTime = false;
            this.defaultValueDate = false;
            this.defaultValueDateTime = false;
        } else if (widgetType === 'date') {
            this.defaultValueInput = false;
            this.defaultValueNumber = false;
            this.defaultValueTime = false;
            this.defaultValueDate = true;
            this.defaultValueDateTime = false;
        } else if (widgetType === 'time') {
            this.defaultValueInput = false;
            this.defaultValueNumber = false;
            this.defaultValueTime = true;
            this.defaultValueDate = false;
            this.defaultValueDateTime = false;
        } else if (widgetType === 'datetime') {
            this.defaultValueInput = false;
            this.defaultValueNumber = false;
            this.defaultValueTime = false;
            this.defaultValueDate = false;
            this.defaultValueDateTime = true;
        }
        this.initOptions = this.EditInitWidgetDate;
        // UI类型
        this.optionsUiType = this.initOptions.uiTyleList;
        for (let i = 0; i < this.optionsUiType.length; i++) {
            if (this.optionsUiType[i].value === 'input') {
                this.formColumn.sUiType = this.initOptions.uiTyleList[i].value;
            }
        }
        // 有效性校验
        this.optionsCheck = this.initOptions.validitionList;
        // 字典表
        this.optionsDic = this.initOptions.dictionaryList;
        if (this.initOptions.dictionaryList.length > 0) {
            this.formColumn.sDictionaryId = this.initOptions.dictionaryList[0].value;
            this.dictionaryChange(this.formColumn.sDictionaryId);
        }
        this.initEditData();
    },

    // 定义变量
    data() {
        return {
            // 表单信息
            formColumn: {
                iOrder: 0,
                sColumnName: '',
                sColumnNotes: '',
                iPrimaryKey: false,
                iCanEmpty: true,
                sUiType: '',
                sValidityId: '',
                sDictionaryId: '',
                sGroupId: '',
                sGroupMark: '',
                sDefaultValue: ''
            },
            validityVisable: true,
            groupIdVisable: false,
            groupMarkVisable: false,
            dictionaryVisable: false,
            defaultValueInput: true,
            defaultValueNumber: false,
            editItemNew: {},
            initOptions: {},
            formLabelWidth: '30%',
            // 对表单进行数据验证
            rules: {
                sColumnName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ]
            }
        };
    },

    // 定义并实现方法体
    methods: {
        // 获取字段类型对应的控件
        getColumnType(columnType) {
            let widgetType;
            switch (columnType) {
                case 'int':
                case 'integer':
                case 'INT':
                case 'INTEGER':
                case 'NUMBER':
                    widgetType = 'inputNumber';
                    break;
                case 'date':
                case 'DATE':
                    widgetType = 'date';
                    break;
                case 'time':
                    widgetType = 'time';
                    break;
                case 'datetime':
                case 'TIMESTAMP':
                case 'TIMESTAMP(6)':
                    widgetType = 'datetime';
                    break;
                default:
                    widgetType = 'input';
                    break;
            }
            return widgetType;
        },

        // 初始化编辑数据
        initEditData() {
            this.formColumn.iOrder = this.editItemNew.iOrder;
            this.formColumn.sColumnName = this.editItemNew.sColumnName;
            this.formColumn.sColumnNotes = this.editItemNew.sColumnNotes;
            this.formColumn.iPrimaryKey = this.editItemNew.iPrimaryKey === 1 ? true : false;
            this.formColumn.iCanEmpty = this.editItemNew.iCanEmpty === 0 ? true : false;
            this.formColumn.iType = this.editItemNew.iType;
            this.formColumn.sGroupMark = this.editItemNew.sGroupMark;
            this.formColumn.sUiType = this.editItemNew.sUiType;
            this.formColumn.sValidityId = this.editItemNew.sValidityId === null ? '0' : this.editItemNew.sValidityId;
            this.formColumn.sGroupMark = this.editItemNew.sGroupMark;
            this.formColumn.sGroupId = this.editItemNew.sGroupId;
            this.formColumn.sDefaultValue = this.editItemNew.sDefaultValue === 'NULL' ? null : this.editItemNew.sDefaultValue;
            this.uiTypeChange();
        },

        // ui类型change事件
        uiTypeChange() {
            let uiType = this.formColumn.sUiType;
            if (uiType === 'select' || uiType === 'radio' || uiType === 'checkbox' || uiType === 'checkboxgroup') {
                this.validityVisable = false;
                this.dictionaryVisable = true;
                this.groupIdVisable = true;
                this.groupMarkVisable = true;
            } else {
                this.validityVisable = true;
                this.dictionaryVisable = false;
                this.groupIdVisable = false;
                this.groupMarkVisable = false;
            }
        },

        // 字典表change事件
        dictionaryChange(param) {
            // 根据字典表id查询所有字段
            if (param == null || param === '' || param === undefined) {
                return;
            }
            let queryVo = {};
            queryVo.sTrusteeshipId = param;
            dlgColumnApi.listColumnsByTrusteeshipId(JSON.stringify(queryVo), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/tableController/listColumnsByTrusteeshipId', response.data.statusMessage);
                    return;
                }
                this.optionsColumn = response.data.content;
                if (this.optionsColumn.length > 0) {
                    this.formColumn.sGroupId = this.optionsColumn[0].sColumnId;
                }
            });
        },

        // 提交数据
        submitForm(formColumn) {
            this.$refs[formColumn].validate(valid => {
                if (valid) {
                    let content = {
                        sColumnId: this.editItemNew.sColumnId,
                        iOrder: this.formColumn.iOrder,
                        sColumnName: this.formColumn.sColumnName,
                        sColumnNotes: this.formColumn.sColumnNotes,
                        iPrimaryKey: this.formColumn.iPrimaryKey === true ? 1 : 0,
                        iCanEmpty: this.formColumn.iCanEmpty === true ? 0 : 1,
                        sUiType: this.formColumn.sUiType,
                        sValidityId: this.formColumn.sValidityId,
                        sDictionaryId: this.formColumn.sDictionaryId,
                        sGroupMark: this.formColumn.sGroupMark,
                        sGroupId: this.formColumn.sGroupId,
                        sDefaultValue: this.formColumn.sDefaultValue,
                        sTrusteeshipId: this.editItemNew.sTrusteeshipId
                    };
                    dlgColumnApi.updateTrusteeshipColumn(JSON.stringify(content), response => {
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('dlgColumnApi.updateTrusteeshipColumn', response);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('pgCommon.MODIFY_SUCCESS'), type: 'success' });
                        this.columnDialogClose();
                        this.$emit('onSuccess', content);
                        this.$emit('queryDataList');
                    });
                }
            });
        },

        // 主键change
        pryChange(val) {
            this.formColumn.iCanEmpty = val === true ? true : this.formColumn.iCanEmpty;
        },

        // 取消
        cancel() {
            this.columnDialogClose();
        },

        // 关闭窗口之前需要调用的方法
        columnDialogClose() {
            this.$emit('columnDialogClose');
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
